module.exports = __webpack_public_path__ + "static/PixelFed-1a53b259370396a758b1987cdcce7fe7.svg";